module.exports = __webpack_public_path__ + "static/media/iconeDestinatário.58c414f5.svg";